module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-13.56492a77.jpg";